import React, { useEffect, useState } from "react";
import {
  Button, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Box, Input, FormControlLabel, Switch, Tabs, Tab,
  Select, MenuItem,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  Typography, CircularProgress, Snackbar, Alert, Card, CardContent,
  Grid, Chip, IconButton, Tooltip, Avatar, Divider, Container
} from "@mui/material";
import { getPlane, createPlane, updatePlane } from "../../../Services/plansApi";
import { getAllFeatures, removeFeatureFromPlane } from "../../../Services/FeaturesApi";
import FeaturesList from "./FeaturesTap";
import AddFeaturesDialog from "./AddFeaturesDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ImageIcon from "@mui/icons-material/Image";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import FeaturedPlayListIcon from "@mui/icons-material/FeaturedPlayList";


const PlansPageMain = () => {
  const [plans, setPlans] = useState([]);
  // قراءة الفلتر من اللوكال ستورج أو افتراضي "all"
  const initialFilter = typeof window !== "undefined" ? (localStorage.getItem("plans_filter_status") || "all") : "all";
  const [filterStatus, setFilterStatus] = useState(initialFilter);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    plane_name: "",
    desc: "",
    slug: "",
    monthly_price: "",
    yearly_price: "",
    price: "",
    descount: "",   // ✅ تصحيح الاسم
    status: true,
    image: null,
    plane_order: "", // <-- أضفنا حقل الترتيب
  });
  const [submitting, setSubmitting] = useState(false);
  const [editId, setEditId] = useState(null);
  const [tab, setTab] = useState(0);
  const [viewPlan, setViewPlan] = useState(null); // لعرض تفاصيل الباقة
  const [addFeatureDialog, setAddFeatureDialog] = useState({
    open: false,
    plane_id: null,
    selectedPlanFeatures: [],
  });
  const [featuresList, setFeaturesList] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState({
    open: false,
    planeId: null,
    featureId: null,
    featureName: "",
  });
  const [successMsg, setSuccessMsg] = useState("");

  // دالة لجلب الباقات
  const fetchPlans = async () => {
    setLoading(true);
    try {
      const res = await getPlane();
      const palnes = res?.data?.data?.palnes || [];

      // فرز تصاعدي حسب plane_order، العناصر بدون قيمة تذهب للنهاية
      palnes.sort((a, b) => {
        const A = a?.plane_order != null ? Number(a.plane_order) : Number.MAX_SAFE_INTEGER;
        const B = b?.plane_order != null ? Number(b.plane_order) : Number.MAX_SAFE_INTEGER;
        return A - B;
      });

      setPlans(palnes);
      return palnes;
    } catch (err) {
      console.error("Error fetching plans:", err);
      setPlans([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  // جلب الفيتشرات مرة واحدة عند التحميل
  useEffect(() => {
    getAllFeatures().then((data) => {
      setFeaturesList(data.data || []);
    });
  }, []);

  useEffect(() => {
    fetchPlans();
  }, []);

  // حفظ قيمة الفلتر في localStorage عند التغيير
  useEffect(() => {
    try {
      localStorage.setItem("plans_filter_status", filterStatus);
    } catch (e) {
      // ignore
    }
  }, [filterStatus]);

  // قوائم الباقات بعد تطبيق الفلتر
  const filteredPlans = plans.filter((plan) => {
    if (filterStatus === "all") return true;
    return Number(plan.status) === Number(filterStatus);
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "file") {
      setForm((prev) => ({ ...prev, [name]: files[0] }));
    } else if (type === "checkbox") {
      setForm((prev) => ({ ...prev, [name]: checked ? 1 : 0 }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleEdit = (plan) => {
    setEditId(plan.id);
    setForm({
      plane_name: plan.plane_name || "",
      desc: plan.desc || "",
      slug: plan.slug || "",
      monthly_price: plan.monthly_price || "",
      yearly_price: plan.yearly_price || "",
      price: plan.price || "",
      descount: plan.descount || plan.descount || "",
      status: plan.status === 1,
      image: null,
      plane_order: plan.plane_order !== undefined && plan.plane_order !== null ? plan.plane_order : "", // <-- تعبئة الترتيب عند التعديل
    });
    setOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      if (editId) {
        await updatePlane(editId, {
          ...form,
          status: form.status ? 1 : 0,
        });
      } else {
        await createPlane({
          ...form,
          status: form.status ? 1 : 0,
        });
      }
      setOpen(false);
      setForm({
        plane_name: "",
        desc: "",
        slug: "",
        monthly_price: "",
        yearly_price: "",
        price: "",
        descount: "",
        status: true,
        image: null,
        plane_order: "", // <-- إعادة تهيئة الحقل بعد الإرسال
      });
      setEditId(null);
      fetchPlans();
    } catch (err) {
      console.error("Error creating/updating plan:", err);
    }
    setSubmitting(false);
  };

  const handleAddFeature = (plan) => {
    setAddFeatureDialog({
      open: true,
      plane_id: plan.id,
      selectedPlanFeatures: plan.features || [],
    });
  };

  // دالة فتح رسالة التأكيد
  const handleRemoveFeatureFromPlan = (planeId, featureId, featureName) => {
    setConfirmDelete({
      open: true,
      planeId,
      featureId,
      featureName,
    });
  };

  // تنفيذ الحذف بعد التأكيد
  const confirmDeleteFeature = async () => {
    try {
      await removeFeatureFromPlane(confirmDelete.planeId, confirmDelete.featureId);
      setConfirmDelete({ open: false, planeId: null, featureId: null, featureName: "" });
      setSuccessMsg("تم حذف الفيتشر بنجاح");
      fetchPlans();
    } catch (err) {
      alert("حدث خطأ أثناء حذف الفيتشر");
      setConfirmDelete({ open: false, planeId: null, featureId: null, featureName: "" });
    }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Card elevation={3} sx={{ mb: 3, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <CardContent>
          <Typography variant="h4" sx={{ color: 'white', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
            <FeaturedPlayListIcon sx={{ fontSize: 40 }} />
            إدارة الباقات والميزات
          </Typography>
        </CardContent>
      </Card>

      <Tabs 
        value={tab} 
        onChange={(_, v) => setTab(v)} 
        sx={{ 
          mb: 3,
          '& .MuiTab-root': {
            fontSize: '1.1rem',
            fontWeight: 'bold',
            minHeight: 64
          }
        }}
      >
        <Tab label="الباقات" icon={<LocalOfferIcon />} iconPosition="start" />
        <Tab label="الفيتشرات" icon={<FeaturedPlayListIcon />} iconPosition="start" />
      </Tabs>

      {tab === 0 && (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333' }}>
                الباقات المتوفرة ({filteredPlans.length})
              </Typography>
              <Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                size="small"
                sx={{ minWidth: 160 }}
              >
                <MenuItem value="all">الكل</MenuItem>
                <MenuItem value="1">نشطة فقط</MenuItem>
                <MenuItem value="0">غير نشطة</MenuItem>
              </Select>
            </Box>
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              startIcon={<AddCircleIcon />}
              onClick={() => { setOpen(true); setEditId(null); }}
              sx={{ 
                borderRadius: 2,
                px: 4,
                py: 1.5,
                boxShadow: 3,
                background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                '&:hover': {
                  boxShadow: 6,
                  transform: 'translateY(-2px)',
                  transition: 'all 0.3s'
                }
              }}
            >
              إضافة باقة جديدة
            </Button>
          </Box>

          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
              <CircularProgress size={60} />
            </Box>
          ) : (
            <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 2 }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>اسم الباقة</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>الترتيب</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>الصورة</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>الوصف</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>Slug</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>السعر الشهري</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>السعر السنوي</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>السعر</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>الخصم</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>الحالة</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>الفيتشرات</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>تاريخ الإنشاء</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>إجراءات</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredPlans.map((plan) => (
                    <TableRow 
                      key={plan.id}
                      sx={{ 
                        '&:hover': { 
                          bgcolor: '#f9f9f9',
                          transition: 'all 0.2s'
                        }
                      }}
                    >
                      <TableCell>
                        <Typography sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                          {plan.plane_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography sx={{ fontWeight: 'bold' }}>
                          {plan.plane_order !== undefined && plan.plane_order !== null ? plan.plane_order : "-"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {plan.image ? (
                          <Avatar 
                            src={plan.image} 
                            alt="plan" 
                            variant="rounded"
                            sx={{ width: 60, height: 60, boxShadow: 2 }}
                          />
                        ) : (
                          <Avatar variant="rounded" sx={{ width: 60, height: 60, bgcolor: '#e0e0e0' }}>
                            <ImageIcon />
                          </Avatar>
                        )}
                      </TableCell>
                      <TableCell sx={{ maxWidth: 200 }}>
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          {plan.desc}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip label={plan.slug} size="small" variant="outlined" />
                      </TableCell>
                      <TableCell>
                        <Chip 
                          icon={<AttachMoneyIcon />}
                          label={`${plan.monthly_price} جنيه`}
                          color="primary"
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Chip 
                          icon={<AttachMoneyIcon />}
                          label={`${plan.yearly_price} جنيه`}
                          color="secondary"
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Typography sx={{ fontWeight: 'bold' }}>
                          {plan.price} جنيه
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {(plan.descount || plan.descount) ? (
                          <Chip 
                            label={`${plan.descount || plan.descount}%`}
                            color="success"
                            size="small"
                          />
                        ) : (
                          <span style={{ color: '#999' }}>لا يوجد</span>
                        )}
                      </TableCell>
                      <TableCell>
                        <Chip
                          icon={plan.status === 1 ? <CheckCircleIcon /> : <CancelIcon />}
                          label={plan.status === 1 ? "نشطة" : "غير نشطة"}
                          color={plan.status === 1 ? "success" : "default"}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={(plan.features && plan.features.length) || 0}
                          color="info"
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          {plan.created_at ? plan.created_at.split("T")[0] : ""}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                          <Tooltip title="عرض التفاصيل">
                            <IconButton
                              color="info"
                              size="small"
                              onClick={() => setViewPlan(plan)}
                              sx={{ 
                                bgcolor: '#e3f2fd',
                                '&:hover': { bgcolor: '#bbdefb' }
                              }}
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="تعديل">
                            <IconButton
                              color="secondary"
                              size="small"
                              onClick={() => handleEdit(plan)}
                              sx={{ 
                                bgcolor: '#f3e5f5',
                                '&:hover': { bgcolor: '#e1bee7' }
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="إضافة فيتشرات">
                            <IconButton
                              color="success"
                              size="small"
                              onClick={() => handleAddFeature(plan)}
                              sx={{ 
                                bgcolor: '#e8f5e9',
                                '&:hover': { bgcolor: '#c8e6c9' }
                              }}
                            >
                              <AddCircleIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </>
      )}

      {tab === 1 && (
        <Box sx={{ mt: 2 }}>
          <FeaturesList />
        </Box>
      )}

      {/* Dialog لإضافة/تعديل باقة */}
      <Dialog 
        open={open} 
        onClose={() => { setOpen(false); setEditId(null); }} 
        maxWidth="md" 
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2 }
        }}
      >
        <DialogTitle sx={{ 
          bgcolor: editId ? '#9c27b0' : '#1976d2', 
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          {editId ? <EditIcon /> : <AddCircleIcon />}
          {editId ? "تعديل باقة" : "إضافة باقة جديدة"}
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2} sx={{ mt: 0.5 }}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="اسم الباقة"
                  name="plane_name"
                  value={form.plane_name}
                  onChange={handleChange}
                  required
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Slug"
                  name="slug"
                  value={form.slug}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="الوصف"
                  name="desc"
                  value={form.desc}
                  onChange={handleChange}
                  required
                  multiline
                  rows={3}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="السعر الشهري"
                  name="monthly_price"
                  value={form.monthly_price}
                  onChange={handleChange}
                  type="number"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="السعر السنوي"
                  name="yearly_price"
                  value={form.yearly_price}
                  onChange={handleChange}
                  type="number"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="السعر"
                  name="price"
                  value={form.price}
                  onChange={handleChange}
                  type="number"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="ترتيب الباقة"
                  name="plane_order"
                  value={form.plane_order}
                  onChange={handleChange}
                  type="number"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="الخصم (%)"
                  name="descount"
                  value={form.descount}
                  onChange={handleChange}
                  type="number"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!form.status}
                      onChange={handleChange}
                      name="status"
                      color="primary"
                    />
                  }
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {form.status ? <CheckCircleIcon color="success" /> : <CancelIcon />}
                      <Typography>{form.status ? "نشطة" : "غير نشطة"}</Typography>
                    </Box>
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ 
                  border: '2px dashed #ccc', 
                  borderRadius: 2, 
                  p: 2,
                  textAlign: 'center',
                  bgcolor: '#f9f9f9'
                }}>
                  <ImageIcon sx={{ fontSize: 40, color: '#999', mb: 1 }} />
                  <Input
                    type="file"
                    name="image"
                    onChange={handleChange}
                    fullWidth
                  />
                  <Typography variant="caption" sx={{ color: '#666', mt: 1 }}>
                    اختر صورة للباقة
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button 
            onClick={() => { setOpen(false); setEditId(null); }} 
            disabled={submitting}
            variant="outlined"
            size="large"
          >
            إلغاء
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={submitting}
            size="large"
            sx={{ minWidth: 120 }}
          >
            {submitting ? <CircularProgress size={24} /> : (editId ? "تحديث" : "إضافة")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog عرض تفاصيل الباقة */}
      <Dialog 
        open={!!viewPlan} 
        onClose={() => setViewPlan(null)} 
        maxWidth="md" 
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2 }
        }}
      >
        <DialogTitle sx={{ 
          bgcolor: '#4caf50', 
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <VisibilityIcon />
          تفاصيل الباقة
        </DialogTitle>
        <DialogContent>
          {viewPlan && (
            <Box sx={{ py: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Card variant="outlined" sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#1976d2' }}>
                      {viewPlan.plane_name}
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="textSecondary">الوصف:</Typography>
                        <Typography variant="body1">{viewPlan.desc}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" color="textSecondary">Slug:</Typography>
                        <Chip label={viewPlan.slug} size="small" />
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="body2" color="textSecondary">السعر الشهري:</Typography>
                        <Chip icon={<AttachMoneyIcon />} label={`${viewPlan.monthly_price} جنيه`} color="primary" />
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="body2" color="textSecondary">السعر السنوي:</Typography>
                        <Chip icon={<AttachMoneyIcon />} label={`${viewPlan.yearly_price} جنيه`} color="secondary" />
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="body2" color="textSecondary">السعر:</Typography>
                        <Typography variant="h6">{viewPlan.price} جنيه</Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="body2" color="textSecondary">الخصم:</Typography>
                        <Chip label={`${viewPlan.descount || viewPlan.descount || 0}%`} color="success" />
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="body2" color="textSecondary">الحالة:</Typography>
                        <Chip
                          icon={viewPlan.status === 1 ? <CheckCircleIcon /> : <CancelIcon />}
                          label={viewPlan.status === 1 ? "نشطة" : "غير نشطة"}
                          color={viewPlan.status === 1 ? "success" : "default"}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="body2" color="textSecondary">تاريخ الإنشاء:</Typography>
                        <Typography variant="body2">{viewPlan.created_at}</Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="body2" color="textSecondary">ترتيب الباقة:</Typography>
                        <Typography variant="body2">{viewPlan.plane_order ?? "-"}</Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card variant="outlined" sx={{ p: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <FeaturedPlayListIcon color="primary" />
                      الفيتشرات ({(viewPlan.features || []).length})
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    {(viewPlan.features || []).length === 0 ? (
                      <Typography color="textSecondary" sx={{ textAlign: 'center', py: 2 }}>
                        لا توجد فيتشرات لهذه الباقة
                      </Typography>
                    ) : (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {(viewPlan.features || []).map((f, i) => (
                          <Card key={i} variant="outlined" sx={{ p: 1.5, bgcolor: '#fafafa' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                  {f.name}
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
                                  <Chip label={`المفتاح: ${f.key}`} size="small" variant="outlined" />
                                  <Chip label={`القيمة: ${f.pivot?.value}`} size="small" color="primary" />
                                  <Chip label={`شهري: ${f.pivot?.monthly_cost}`} size="small" color="info" />
                                  <Chip label={`سنوي: ${f.pivot?.yearly_cost}`} size="small" color="secondary" />
                                </Box>
                              </Box>
                              <Tooltip title="حذف الفيتشر">
                                <IconButton
                                  color="error"
                                  size="small"
                                  onClick={() => handleRemoveFeatureFromPlan(viewPlan.id, f.id, f.name)}
                                  sx={{ 
                                    bgcolor: '#ffebee',
                                    '&:hover': { bgcolor: '#ffcdd2' }
                                  }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Card>
                        ))}
                      </Box>
                    )}
                  </Card>
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={() => setViewPlan(null)} variant="contained" size="large">
            إغلاق
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog تأكيد حذف الفيتشر */}
      <Dialog 
        open={confirmDelete.open} 
        onClose={() => setConfirmDelete({ open: false, planeId: null, featureId: null, featureName: "" })}
        PaperProps={{
          sx: { borderRadius: 2 }
        }}
      >
        <DialogTitle sx={{ 
          bgcolor: '#f44336', 
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <DeleteIcon />
          تأكيد الحذف
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <CancelIcon sx={{ fontSize: 60, color: '#f44336', mb: 2 }} />
            <Typography variant="h6">
              هل أنت متأكد أنك تريد حذف الفيتشر
            </Typography>
            <Chip 
              label={confirmDelete.featureName} 
              color="error" 
              sx={{ mt: 1, fontWeight: 'bold' }}
            />
            <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
              من الخطة؟ لا يمكن التراجع عن هذا الإجراء.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button 
            onClick={() => setConfirmDelete({ open: false, planeId: null, featureId: null, featureName: "" })}
            variant="outlined"
            size="large"
          >
            إلغاء
          </Button>
          <Button 
            color="error" 
            onClick={confirmDeleteFeature}
            variant="contained"
            size="large"
            startIcon={<DeleteIcon />}
          >
            تأكيد الحذف
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar لرسالة النجاح */}
      <Snackbar
        open={!!successMsg}
        autoHideDuration={3000}
        onClose={() => setSuccessMsg("")}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert 
          onClose={() => setSuccessMsg("")} 
          severity="success" 
          sx={{ 
            width: "100%",
            fontSize: '1.1rem',
            boxShadow: 3
          }}
          icon={<CheckCircleIcon fontSize="inherit" />}
        >
          {successMsg}
        </Alert>
      </Snackbar>

      {/* Dialog إضافة فيتشرات */}
      <AddFeaturesDialog
        open={addFeatureDialog.open}
        onClose={() => setAddFeatureDialog({ open: false, plane_id: null, selectedPlanFeatures: [] })}
        plane_id={addFeatureDialog.plane_id}
        featuresList={featuresList}
        selectedPlanFeatures={addFeatureDialog.selectedPlanFeatures}
        onSuccess={async () => {
          // أعِد جلب الباقات، ثم حدّث قائمة الفيتشرات المعروضة في الديالوج الحالي دون إغلاقه
          const updatedPlans = await fetchPlans();
          const updatedPlan = (updatedPlans || []).find(p => String(p.id) === String(addFeatureDialog.plane_id));
          if (updatedPlan) {
            setAddFeatureDialog((s) => ({ ...s, selectedPlanFeatures: updatedPlan.features || [] }));
          }
        }}
      />
    </Container>
  );
};

export default PlansPageMain;
